import { overridesInMinutes } from './taskWorkMinutes';

const LENGTH_TEXT = [
  'workTime',
  'transportTime',
  'timePerUnit',
  'timePerTransportAtUnitPrice',
  'elapsedTime',
];

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === Object.prototype;

/**
 * A request body without the lengths written as text. The backend still returns them next to the
 * minutes, and objects read from it are spread back into requests. A length sent as text wins
 * over its minutes, so a text sent back unchanged would undo a change made to the minutes.
 */
export const withoutLengthText = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return value.map(withoutLengthText) as T;
  }
  if (!isPlainObject(value)) {
    return value;
  }

  return Object.fromEntries(
    Object.entries(value)
      .filter(([key, field]) => !(LENGTH_TEXT.includes(key) && typeof field === 'string'))
      .map(([key, field]) => [
        key,
        key === 'intervalOverrides' && isPlainObject(field)
          ? overridesInMinutes(field)
          : withoutLengthText(field),
      ])
  ) as T;
};
